import {APP_INITIALIZER, ErrorHandler, NgModule} from '@angular/core';
import {BrowserModule} from '@angular/platform-browser';

import {AppRoutingModule} from './app-routing.module';
import {AppComponent} from './app.component';
import {NavComponent} from './nav/nav.component';
import {AuthComponent} from './components/auth/auth.component';
import {FooterComponent} from './components/footer/footer.component';
import {SessionComponent} from './components/session/session.component';
import {HomeComponent} from 'projects/free/src/app/routes/home/home.component';
import {ArticlesComponent} from 'projects/free/src/app/routes/articles/articles.component';
import {EyeTrackingTestComponent} from 'projects/free/src/app/routes/eye-tracking-test/eye-tracking-test.component';
import {PageNotFoundComponent} from 'projects/free/src/app/routes/page-not-found/page-not-found.component';
import {QuestionnaireComponent} from 'projects/free/src/app/routes/questionnaire/questionnaire.component';
import {ResultsComponent} from 'projects/free/src/app/routes/results/results.component';
import {ArticleListComponent} from 'projects/free/src/app/routes/articles/article-list/article-list.component';
import {ArticleItemComponent} from 'projects/free/src/app/routes/articles/article-item/article-item.component';
import {
  NgbAccordionModule,
  NgbDatepickerModule,
  NgbDropdownModule,
  NgbModalModule,
  NgbNavModule, NgbProgressbarModule,
  NgbTooltipModule
} from '@ng-bootstrap/ng-bootstrap';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {AngularFireAuthModule} from '@angular/fire/compat/auth';
import {AngularFireStorageModule} from '@angular/fire/compat/storage';
import {AngularFireDatabaseModule} from '@angular/fire/compat/database';
import {SigninComponent} from './components/auth/signin/signin.component';
import {SignupComponent} from './components/auth/signup/signup.component';
import {HttpClient, HttpClientModule} from '@angular/common/http';
import {EyeTrackerModule} from 'projects/eye-tracker/src/lib/eye-tracker.module';
import {CalibrationComponent} from './routes/calibration/calibration.component';
import {TranslateLoader, TranslateModule} from '@ngx-translate/core';
import {SharedModule} from 'projects/shared/src/lib/shared.module';
import {FormlyModule} from '@ngx-formly/core';
import {FormlyBootstrapModule} from '@ngx-formly/bootstrap';
import {NgxMaskModule} from 'ngx-mask';
import {WhatIsAnimaModalComponent} from './components/what-is-anima-modal/what-is-anima-modal.component';
import {environment} from '../environments/environment';
import {AngularFireModule} from '@angular/fire/compat';
import {AuthService} from 'projects/firebase/src/lib/services/auth.service';
import {TermsAndConditionsComponent} from './routes/terms-and-conditions/terms-and-conditions.component';
import {PrivacyPolicyComponent} from './routes/privacy-policy/privacy-policy.component';
import {NoticeOfPrivacyPracticesComponent} from './routes/notice-of-privacy-practices/notice-of-privacy-practices.component';
import {NoticeOfNondiscriminationComponent} from './routes/notice-of-nondiscrimination/notice-of-nondiscrimination.component';
import {ToastrModule} from 'ngx-toastr';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import {SlickCarouselModule} from 'ngx-slick-carousel';
import {SubscribeComponent} from './components/subscribe/subscribe.component';
import {SocialSharingComponent} from './components/social-sharing/social-sharing.component';
import {NgxPayPalModule} from 'ngx-paypal';
import {PaymentComponent} from 'projects/free/src/app/components/payment/payment.component';
import {FaqComponent} from './components/faq/faq.component';
import {PackagesComponent} from './components/packages/packages.component';
import {UserSessionsComponent} from './routes/user-sessions/user-sessions.component';
import {GraphComponent} from './components/graph/graph.component';
import {DataService} from 'projects/firebase/src/lib/services/data.service';
import {ConfirmSignInComponent} from './components/auth/confirm-sign-in/confirm-sign-in.component';
import {NotSupportedComponent} from './components/not-supported/not-supported.component';
import { FilterByPipe } from './services/filter-by.pipe';
import {TranslateHttpLoader} from '@ngx-translate/http-loader';
import { AboutUsComponent } from './routes/about-us/about-us.component';
import {FeaturedBlogPostsComponent} from './components/featured-blog-posts/featured-blog-posts.component';
import {GoogleTagManagerService} from 'angular-google-tag-manager';
import {Router} from '@angular/router';
import {TraceModule, TraceService} from '@sentry/angular';
import { AfterPaymentComponent } from './routes/after-payment/after-payment.component';
export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http);
}
@NgModule({
  declarations: [
    AppComponent,
    HomeComponent,
    ArticlesComponent,
    EyeTrackingTestComponent,
    PageNotFoundComponent,
    QuestionnaireComponent,
    ResultsComponent,
    ArticleListComponent,
    ArticleItemComponent,
    NavComponent,
    AuthComponent,
    FooterComponent,
    SessionComponent,
    SigninComponent,
    SignupComponent,
    CalibrationComponent,
    WhatIsAnimaModalComponent,
    PaymentComponent,
    TermsAndConditionsComponent,
    PrivacyPolicyComponent,
    NoticeOfPrivacyPracticesComponent,
    NoticeOfNondiscriminationComponent,
    SubscribeComponent,
    SocialSharingComponent,
    FaqComponent,
    PackagesComponent,
    UserSessionsComponent,
    GraphComponent,
    ConfirmSignInComponent,
    NotSupportedComponent,
    FilterByPipe,
    AboutUsComponent,
    FeaturedBlogPostsComponent,
    AfterPaymentComponent
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    HttpClientModule,
    AppRoutingModule,
    NgbAccordionModule,
    NgbDropdownModule,
    NgbAccordionModule,
    NgbModalModule,
    NgbDatepickerModule,
    NgbNavModule,
    NgbTooltipModule,
    FormsModule,
    ReactiveFormsModule,
    AngularFireModule.initializeApp(environment.firebase),
    AngularFireAuthModule,
    AngularFireStorageModule,
    AngularFireDatabaseModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient]
      },
      defaultLanguage: 'en'
    }),
    FormlyModule.forRoot({
      types: [
        {
          name: 'text',
          extends: 'input',
          defaultOptions: {
            templateOptions: {
              type: 'text',
            },
          },
        }
      ],
      validationMessages: [
        {name: 'required', message: 'This field is required'},
      ],
    }),
    FormlyBootstrapModule,
    NgxMaskModule.forRoot(),
    SharedModule.forRoot({env: environment}),
    EyeTrackerModule.forRoot({apiUrl: environment.apiUrl}),
    ToastrModule.forRoot(),
    SlickCarouselModule,
    NgxPayPalModule,
    TraceModule,
    NgbProgressbarModule
  ],
  providers: [
    AuthService,
    DataService,
    {provide: 'googleTagManagerId', useValue: environment.googleTagId},
    GoogleTagManagerService,
    {
      provide: APP_INITIALIZER,
      useFactory: () => () => {},
      deps: [TraceService],
      multi: true,
    },
  ],
  exports: [
    NotSupportedComponent,
    AboutUsComponent
  ],
  bootstrap: [AppComponent]
})
export class AppModule {
}
